module.exports = __webpack_public_path__ + "img/object-remover-before.863c97f2.webp";